/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'

export const useDeactivateAccount = (userID: string) => {
  const axios = useContext(AxiosContext)
  return useMutation({
    mutationKey: [ReactQueryKeys.DEACTIVATE_ACCOUNT, userID],
    mutationFn: async () => {
      const response = await axios.api.post('ajax/users', {
        requestType: 'setAccountStatus',
        userID: userID,
        accountStatus: 0,
        format: 'json',
      })
      return response.data
    },
  })
}
